import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui';
import type { StatsData } from '../../model/types';
import { LostDamagedStatsCard } from './lost-damaged-stats-card';

interface MovementsStatsProps {
  stats: StatsData | null;
  isLoading: boolean;
}

export function MovementsStats({ stats, isLoading }: MovementsStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <StatCard label={t('welcome.chart.totvol.rec.label')} value={stats?.totalVolume || ''} isLoading={isLoading} />
      <LostDamagedStatsCard lost={stats?.lossTotal} damaged={stats?.damageTotal} isLoading={isLoading} />
    </div>
  );
}
